import './Tree.css';

const FolderIcon = () => (
    <svg width="13" height="11" viewBox="0 0 13 11" fill="currentColor" style={{ flexShrink: 0, opacity: 0.8 }}>
        <path d="M5.121 0H1C.448 0 0 .448 0 1v9c0 .552.448 1 1 1h11c.552 0 1-.448 1-1V3c0-.552-.448-1-1-1H6.5L5.121 0z" />
    </svg>
);

const HashIcon = () => (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="currentColor" style={{ flexShrink: 0, opacity: 0.7 }}>
        <path d="M1 4h9M1 8h9M4 1L3 11M8 1L7 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    </svg>
);

function countChildren(obj) {
    if (!obj) return 0;
    if (Array.isArray(obj)) return obj.length;
    if (typeof obj === 'object') return Object.keys(obj).length;
    return 0;
}

function parseEntries(obj) {
    if (!obj) return { collections: [], propertyCount: 0 };

    if (Array.isArray(obj)) {
        const collections = obj
            .filter(item => item.modelType?.name === 'SubmodelElementCollection')
            .map(item => ({ name: item.idShort, children: item.value }));
        const propertyCount = obj.filter(item => item.modelType?.name === 'Property').length;
        return { collections, propertyCount };
    }

    if (typeof obj === 'object') {
        const entries = Object.entries(obj);
        const collections = entries
            .filter(([, v]) => v !== null && typeof v === 'object' && !Array.isArray(v))
            .map(([k, v]) => ({ name: k, children: v }));
        const propertyCount = entries.filter(([, v]) => v === null || typeof v !== 'object').length;
        return { collections, propertyCount };
    }

    return { collections: [], propertyCount: 0 };
}

function TreeBranch({ obj, depth }) {
    const { collections, propertyCount } = parseEntries(obj);
    if (collections.length === 0 && propertyCount === 0) return null;

    const listClass = depth === 0
        ? 'stree-children stree-root'
        : 'stree-children';

    return (
        <ul className={listClass}>
            {collections.map(({ name, children }) => {
                const count = countChildren(children);
                return (
                    <li key={name} className="stree-item">
                        <div className="stree-pill">
                            <FolderIcon />
                            {name}
                            {count > 0 && <span className="stree-count">· {count}</span>}
                        </div>
                        <TreeBranch obj={children} depth={depth + 1} />
                    </li>
                );
            })}
            {propertyCount > 0 && (
                <li className="stree-item">
                    <div className="stree-prop-badge">
                        <HashIcon />
                        {propertyCount} {propertyCount === 1 ? 'property' : 'properties'}
                    </div>
                </li>
            )}
        </ul>
    );
}

function SubmodelTree({ name, data }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "6px", padding: "12px 14px 10px" }}>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", color: "#7c7c7c", letterSpacing: "0.06em", textTransform: "uppercase", minWidth: "38px" }}>Type</span>
                    <span style={{ background: "#f1f1f1", border: "1px solid #d3d3d3", borderRadius: "4px", padding: "2px 8px", fontSize: "12px", color: "#202020", fontWeight: "600" }}>Submodel</span>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", color: "#7c7c7c", letterSpacing: "0.06em", textTransform: "uppercase", minWidth: "38px" }}>Name</span>
                    <span style={{ background: "rgba(38,144,68,0.08)", border: "1px solid rgba(38,144,68,0.3)", borderRadius: "4px", padding: "2px 8px", fontSize: "12px", color: "#269044", fontWeight: "600" }}>{name}</span>
                </div>
            </div>
            <div style={{ height: "1px", background: "#d3d3d3" }} />
            <div style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase", color: "#7c7c7c", padding: "8px 14px 4px" }}>Elements</div>
            <div style={{ overflowY: "auto", flex: 1, padding: "4px 14px 12px" }}>
                {data
                    ? <TreeBranch obj={data} depth={0} />
                    : <div style={{ fontSize: "13px", color: "#afafaf", paddingTop: "4px" }}>Loading…</div>
                }
            </div>
        </div>
    );
}

export default SubmodelTree;
